import { useLanguage } from "@/context/language"
import "@/datox/brand-logo.css"

export function DatoxBrandLogo(props: { class?: string; datoxSrc?: string; datoxAlt?: string }) {
  const language = useLanguage()
  return <span data-component="datox-brand-logo" class={props.class}>
    <img data-brand="datox" src={props.datoxSrc ?? "/datox-logo-white.svg"} alt={props.datoxAlt ?? language.t("datox.logo.alt")} />
    <img data-brand="qnb-light" src="/qnb-logo.png" alt={language.t("qnb.logo.alt")} />
    <img data-brand="qnb-dark" src="/qnb-logo-white.png" alt={language.t("qnb.logo.alt")} />
  </span>
}
